PegasusTemplate.SocialFollowUrlProxy = Ember.Object.extend({
  pinterest_url: null,
  facebook_url:  null,
  twitter_url:   null,
  linkedin_url:  null,
  youtube_url:   null,
  google_url:    null,
  instagram_url: null,
  snapchat_url:  null,
  tumblr_url:    null
});
